<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <div>
                    <SemPermissao></SemPermissao>
                </div>
            </div>
            <template v-if="!erro">
                <FormularioForm :formulario="formulario" />
            </template>
        </div>
    </div>
</template>

<script>

    import FormularioForm from "../../components/formularios/FormularioForm.vue"
    import FormularioApi from "../../services/FormularioApi"
    import SemPermissao from "../SemPermissao.vue"
    import metaDados from "../../helpers/metaDados";

    export default {
        name: "FormularioReaproveitar",
        metaInfo() {
            if (!this.formulario) {
                return {};
            }
            let title = this.formulario.texto;
            const description = this.formulario.texto;

            return {
                title,
                titleTemplate: "Reaproveitar %s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                formulario: null,
            };
        },
        components: {
            SemPermissao,
            FormularioForm,
        },
        created() {
            this.formularioApi = new FormularioApi();
            this.carregarFormulario();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarFormulario();
                }
            },
        },

        methods: {
          carregarFormulario: async function () {
            try {
              this.carregando = true;
              this.erro = false;

              const dadosOriginal = await this.formularioApi.getFormulario(this.$route.params.id);
              
              // Aplicamos a limpeza do formulário
              this.formulario = this.limparDadosParaReaproveitar(dadosOriginal);

              this.carregando = false;
            } catch (err) {
              console.error(err);
              this.erro = true;
              this.carregando = false;
            }
          },

          limparDadosParaReaproveitar(dados) {
            // 1. Clonagem profunda para evitar mutação de referência
            const novoForm = JSON.parse(JSON.stringify(dados));

            // 2. Reset do ID (para o Rails entender como novo registro)
            delete novoForm.id;

            // 3. Limpeza dos campos solicitados
            novoForm.titulo = "";
            novoForm.texto = "";
            novoForm.unidade_ids = [];
            novoForm.unidade_id = [];
            novoForm.data_periodo_inicio = null;
            novoForm.data_periodo_final = null;
            novoForm.data_inicio = null;
            novoForm.data_final = null;

            if (novoForm.perguntas_formulario) {
              novoForm.perguntas_formulario = novoForm.perguntas_formulario.map(pf => {
                delete pf.id; // Remove ID do vínculo Pergunta/Formulário
                
                if (pf.alternativas) {
                  pf.alternativas = pf.alternativas.map(alt => {
                    delete alt.id; // Remove ID da alternativa
                    return alt;
                  });
                }
                return pf;
              });
            }

            return novoForm;
          }
        }
    };
</script>

<style lang="scss" scoped>
/* Seus estilos podem ser mantidos aqui */
</style>